import type { ListMemoryThreadsResponse } from '@mastra/client-js';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import mastraClient from '../lib/mastraClient';
import type { AgentNames } from '../types';

const THREADS_QUERY_KEY = ['AI', 'THREADS'];

/**
 * Get the threads for a given agent and resource
 * @param agentName - The agent ID
 * @param resourceId - The resource ID or user ID
 * @returns The threads
 */
export const useThreads = ({ agentName, resourceId, options }: { agentName: AgentNames; resourceId: string; options?: Partial<UseQueryOptions<ListMemoryThreadsResponse>> }) => {
  const isEnabled = Boolean(resourceId) && !resourceId.includes('undefined') && resourceId.trim().length > 0 && (options?.enabled ?? true);

  return useQuery({
    queryKey: [...THREADS_QUERY_KEY, agentName, resourceId],
    queryFn: async () => {
      const client = await mastraClient();
      const threads = await client.listMemoryThreads({ agentId: agentName, resourceId, orderBy: { field: 'createdAt', direction: 'DESC' } });
      return threads;
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    ...options,
    enabled: isEnabled,
  });
};
